import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { put, takeLatest } from 'redux-saga/effects'
import { WebUserModel,FindUserRequestModel, Roles } from '../models'
import { getUser,getRoles,getFindUser } from './UserCRUD'

export interface ActionWithPayload<T> extends Action {
    payload?: T
}

export const actionTypes = {
    SetUser: '[SetUser] Action',
    SetRoles: '[SetRoles] Action',
    setAllUsers: '[setAllUsers] Action',
    addUser: '[addUser] Action'
}

const initialUserState: IUserState = {
    user: undefined,
    roles: undefined,
    allUsers: undefined,
    
}

export interface IUserState {
    user?: WebUserModel
    roles?: Roles[]
    allUsers?: WebUserModel[]
}


export const reducer = persistReducer(
    { storage, key: 'kpmrc-user', whitelist: ['user','roles','allUsers'] },
    (state: IUserState = initialUserState, action: ActionWithPayload<IUserState>) => {
        
        switch (action.type) {
            case actionTypes.SetUser: {
                const user = action.payload?.user
                return { ...state, user }
            }
            case actionTypes.SetRoles: {
                const roles = action.payload?.roles
                return { ...state, roles }
            }
            case actionTypes.setAllUsers: {
                const allUsers = action.payload?.allUsers
                return { ...state, allUsers }
            }
            default:
                return state
        }
    }
)

export const actions = {
    setUser: (user: WebUserModel) => ({ type: actionTypes.SetUser, payload: { user } }),
    setRoles: (roles: Roles[]) => ({ type: actionTypes.SetRoles, payload: { roles } }),
    setAllUsers: (allUsers: WebUserModel[]) => ({ type: actionTypes.setAllUsers, payload: { allUsers } }),
    addUser: ()=>({type: actionTypes.addUser})
}

export function* saga() {
    yield takeLatest(actionTypes.SetUser, function* setUserSaga() {
        const { data: roles } = yield getRoles()
        // const { data: findUser } = yield getFindUser()
        yield put(actions.setRoles(roles))
        // yield put(actions.setFindUser(findUser))
    })
    yield takeLatest(actionTypes.addUser, function* addUserSaga(){
        let findModel:FindUserRequestModel = new FindUserRequestModel();
        const { data: users } = yield getFindUser(findModel);
        yield put(actions.setAllUsers(users));
    })
}